import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

type ContainerProps = {
  $isShowPaywall?: boolean;
};

export const LoadingContainer = styled.div`
  position: absolute;

  display: flex;
  place-content: center center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
`;

export const Container = styled.div<ContainerProps>`
  position: relative;

  display: flex;

  block-size: 530px;

  ${props =>
    props.$isShowPaywall === false &&
    css`
      display: none;
    `}

  ${props =>
    props.$isShowPaywall === true &&
    css`
      block-size: auto;
      min-block-size: 530px;

      ${LoadingContainer} {
        display: none;
      }
    `}

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;

export const Wrapper = styled.div`
  inline-size: 100%;
  block-size: 100%;
`;
